import React, { PureComponent } from 'react'
import { Grid, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import TookanShopInfoItem from './TookanShopInfoItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import { hasAccess } from '../../utils/api'

const TookanShopInfoItemEditable = EditableHOCWrapper(TookanShopInfoItem)

class TookanShopInfo extends PureComponent {
  render() {
    const { shopsList = {}, tookanList = {}, onSave, lastModified, onDelete } = this.props
    const { values = [] } = shopsList

    return (
      <div>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="margin-top-small">
            <div className="table-scroll">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Shop Name</TableCell>
                    <TableCell>Tookan API Key</TableCell>
                    <TableCell>Status</TableCell>
                    {hasAccess() ? <TableCell></TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(values &&
                    values.length &&
                    values.map((shop, index) => {
                      return (
                        <TookanShopInfoItemEditable
                          key={index}
                          dataToEdit={tookanList[shop.id]}
                          isNotLinkedApiKey={
                            tookanList[shop.id] && tookanList[shop.id].apiKey ? false : true
                          }
                          onSave={onSave}
                          lastModified={lastModified}
                          shop={shop}
                          onDelete={onDelete}
                        />
                      )
                    })) ||
                    null}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </div>
    )
  }
}

export default TookanShopInfo



// WEBPACK FOOTER //
// ./src/components/Tookan/TookanShopInfo.js